import React, { Dispatch, FC, SetStateAction } from 'react';
import { AdditionalType, Tourney } from '../../model/interfaces';
import { t } from '../../../../utils/helpers';
import { Tournaments } from '../../../../pages/tournamentsPage/tournamentsPage';
import { FinishedTournamentsItem } from './finishedTournamentsItem/finishedTournamentsItem';

type PropsType = {
  tournaments: Tournaments | null;
  setComponent: Dispatch<SetStateAction<AdditionalType | undefined>>;
  activeItem: string;
  setActiveItem: Dispatch<SetStateAction<string>>;
};

export const FinishedTournaments: FC<PropsType> = ({
  tournaments,
  setComponent,
  activeItem,
  setActiveItem,
}: PropsType) => {
  const finishedTournaments = tournaments && tournaments.finished;

  function handlerShowAdditional(key: string, data: AdditionalType) {
    setActiveItem(key);
    setComponent(data);
  }

  function renderFinishedList(tournaments: Tourney[]) {
    return tournaments.map((item) => {
      return (
        <FinishedTournamentsItem
          item={item}
          handlerShowAdditional={handlerShowAdditional}
          activeItem={activeItem}
          key={item.TourneyID}
        />
      );
    });
  }

  const finishedListJSX =
    finishedTournaments &&
    !!finishedTournaments.length &&
    renderFinishedList(finishedTournaments);

  return (
    <>
      <div className="tournaments__item-header finished__header">
        <div className="finished__header-title">{t('finished')}</div>
        <div className="finished__header-rules">{`${t('tournament')} / ${t(
          'rules'
        )}`}</div>
        <div className="finished__header-director">{t('director')}</div>
        <div className="finished__header-entry">{t('entry_fee')}</div>
        <div className="finished__header-reward">{t('cash_prize')}</div>
      </div>
      <div className="tournaments__item-content">{finishedListJSX}</div>
    </>
  );
};
